import React from 'react';
import CardFooter from "../card/CardFooter";
import { useMedia } from "react-use";

const ShoppingItem = (props) => {
    const isMobile = useMedia("(max-width: 992px)");
    return (
        <section className={`item-box ${props.active ? props.active: ''} ${props.class ? props.class: ""}`}>
            <div className="row">
                <div className="col-xs-8 col-md-8 col-lg-6">
                    <h3 className={`${isMobile ? 'mb-0': 'pt-3'}`}>{props.item.title}</h3>
                    <span className={`${isMobile ? 'light': 'bold'} font-medium`}>{props.price}</span>
                </div>
                <div className="col-xs-4 col-md-4 col-lg-5 image-box">
                    <img src={`${isMobile ? props.item.imageSmall: props.item.image}`} alt="nbn available" />
                </div>
                <div className="col-md-12 col-lg-12 d-none d-lg-block">
                    <ul className="pl-3">
                        {
                            props.features.map((item, key) => {
                                return (
                                    <li key={key}>{item}</li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
            <div className="bottom-container">
                <CardFooter margin={false} handleRemove={props.handleRemoveFromCart} handleAdd={props.handleAddToCart} item={props.item} active={props.active}/>
            </div>
        </section>
    )
}

export default ShoppingItem;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/orderSummary/ShoppingItem.js